package one.healthium.domain.user.models

import loco.GENERAL_GENDER_MEN
import loco.GENERAL_GENDER_WOMEN
import one.healthium.loco.LString
import one.healthium.loco.asLString

enum class Gender(val key: String) {
    Female("0"),
    Male("1");

    fun displayValue(): LString {
        return when (this) {
            Female -> loco.Res.string.GENERAL_GENDER_WOMEN.asLString()
            Male -> loco.Res.string.GENERAL_GENDER_MEN.asLString()
        }
    }

    companion object {
        fun fromKey(key: String?) = entries.firstOrNull { it.key == key } ?: Female
    }
}